import APP_COMPONENTS from "../components/index.js";
function makeFileInputted() {
    return Object.freeze({
        execute
    });
    async function execute(data) {
        const MAX_SIZE = 300 * 1024; // 300kb size limit
        if (!data.file.type || data.file.type !== 'image/jpeg') {
            APP_COMPONENTS.fileForms.reset(data.id);
            APP_COMPONENTS.fileError.show('INVALID FILE', 'Invalid file type. <br>Please choose a jpeg file.');
            return;
        }
        if (data.file.size > MAX_SIZE) {
            APP_COMPONENTS.fileForms.reset(data.id);
            APP_COMPONENTS.fileError.show('FILE SIZE TOO BIG', 'Please choose a file with a size no bigger than 300KB.');
            return;
        }
        APP_COMPONENTS.fileForms.showFile(data.id, data.file.name);
    }
}
const fileInputted = makeFileInputted();
export default fileInputted;
